module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Connect"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "about-ifree-bg"
  }, [_c('div', {
    staticClass: "about-ifree-page"
  }, [_c('h1', {
    staticClass: "banner-title"
  }, [_vm._v(_vm._s(_vm.$t('about_ifree_banner_title')))]), _vm._v(" "), _c('p', {
    staticClass: "banner-content"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('about_ifree_banner_page')) + " ")])])])]), _vm._v(" "), _c('section', {}), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "ifree-team"
  }, [_c('div', {
    staticClass: "ifree-team-wrap"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/about_us/about-us_pic2@2x.jpg"),
      "width": "95%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('div', {
    staticClass: "ifree-team-content"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('about_ifree_ourteam')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('about_ifree_ourteam_content')) + "\n                        ")])])])], 1)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "ifree-aim"
  }, [_c('div', {
    staticClass: "ifree-aim-wrap"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('about_ifree_mission')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('about_ifree_mission_content')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('about_ifree_mission_content1')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "ifree-aim-system"
  }, [(this.languge == 'tc') ? _c('img', {
    attrs: {
      "src": require("../../assets/about_us/ifree_tc@2x.png")
    }
  }) : (this.languge == 'sc') ? _c('img', {
    attrs: {
      "src": require("../../assets/about_us/ifree_sc@2x.png")
    }
  }) : (this.languge == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/about_us/ifree_en@2x.png")
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680ce098","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutiFREE/AboutiFREE.vue
// module id = 822
// module chunks = 0